import {
    ScratchGameResult,
    ScratchGameStatus,
} from "src/containers/wellbeing/rewards/domain/models/scratch-game-result";

export enum MockGameResultStatus {
    Win = "WIN",
    Lose = "LOSE",
}

export const rewardsGameMockResults = new Map<
    MockGameResultStatus,
    ScratchGameResult
>([
    [
        MockGameResultStatus.Win,
        ScratchGameResult.fromJson<ScratchGameResult>({
            id: 1,
            result: ScratchGameStatus.Win,
            url: "raspa-y-gana-vale-400",
        }),
    ],
    [
        MockGameResultStatus.Lose,
        ScratchGameResult.fromJson<ScratchGameResult>({
            id: 1,
            result: ScratchGameStatus.Lose,
            url: "raspa-y-gana-sigue-intentando",
        }),
    ],
]);
